import { Component, OnInit, OnDestroy } from '@angular/core';
import { SponsorsService } from '../services/sponsors.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { ModifySponsorRequest, defaultSponsor, toRequest } from '../sponsors.interfaces';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { NgForm } from '@angular/forms';
import { FormUtil } from '../../core/form.util';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ch-sponsors-edit',
  styleUrls: ['./sponsors-edit.component.css'],
  templateUrl: './sponsors-edit.component.html',
})
export class SponsorsEditComponent implements OnInit, OnDestroy {
  private sub$: Subscription;
  private delete$: Subscription;
  private callSub$: Subscription;

  id: string;
  loading = true;
  sponsor: ModifySponsorRequest = defaultSponsor();

  constructor(private route: ActivatedRoute, private service: SponsorsService, private router: Router, private titleService: Title) {}

  ngOnInit() {
    this.sub$ = this.route.queryParamMap
      .map((params: Params) => params.params.id)
      .switchMap(id => {
        this.id = id;
        if (!this.id) {
          this.titleService.setTitle(`New Sponsor | CODE Hospitality CMS`);
        }
        return this.id ? this.service.getById(id) : Observable.of(defaultSponsor());
      })
      .subscribe(result => {
        this.sponsor = toRequest(result);
        this.titleService.setTitle(`${this.sponsor.name} | Sponsors | CODE Hospitality CMS`);
        this.loading = false;
      });
  }
  updateLogo(logoId: string) {
    this.sponsor.logoId = logoId;
  }

  submitForm(form: NgForm) {
    if (FormUtil.isValid(form)) {
      this.send();
    }
  }

  private send() {
    this.callSub$ = this.id
      ? this.service.update(this.id, this.sponsor).subscribe(_ => this.backToMain())
      : this.service.create(this.sponsor).subscribe(_ => this.backToMain());
  }

  cancel() {
    this.backToMain();
  }

  private backToMain(): void {
    this.router.navigate(['/admin/sponsors']);
  }

  delete() {
    this.delete$ = this.service.delete(this.id).subscribe(_ => this.backToMain());
  }

  ngOnDestroy() {
    if (this.sub$) {
      this.sub$.unsubscribe();
    }
    if (this.delete$) {
      this.delete$.unsubscribe();
    }
    if (this.callSub$) {
      this.callSub$.unsubscribe();
    }
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/sponsors/sponsors-edit/sponsors-edit.component.ts